module.exports = __webpack_public_path__ + "img/s6-300x89.c36eed00.jpg";